import { APP_ROUTES } from "utils/app-routes"
import { LeaderboardIcon, clansIcon } from "assets/images"
import {
  ClashOfDiggersIcon,
  clanUnderIcon,
  leaderboardUnderIcon,
  leaderboardPVP
} from "assets/icons"

export const profileData = {
  common: {
    leaderboard: {
      icon: LeaderboardIcon,
      url: APP_ROUTES.LEADERBOARD
    },
    clan: {
      icon: clansIcon,
      url: APP_ROUTES.CLANS.toString()
    },
    cod: {
      icon: ClashOfDiggersIcon,
      url: import.meta.env.VITE_COD ?? ""
    }
  },
  under: {
    leaderboard: {
      icon: leaderboardUnderIcon,
      url: APP_ROUTES.UNDER.BOSS.LEADERBOARD.toString()
    },
    arenaLeaderboard: {
      icon: leaderboardPVP,
      url: `${APP_ROUTES.UNDER.BOSS.LEADERBOARD}?mode=arena`
    },
    clan: {
      icon: clanUnderIcon,
      url: APP_ROUTES.CLANS.toString()
    },
    cod: {
      icon: ClashOfDiggersIcon,
      url: import.meta.env.VITE_COD ?? ""
    }
  }
}
